import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { HOTEL_URL } from './constant/BaseApiUrl';

export default class GatewayService {
  getGateways() {
    return axios.get(`${HOTEL_URL}${ApiKey.GET_GATEWAYS}`);
  }

  getNewGateway(payload) {
    return axios.get(`${HOTEL_URL}${ApiKey.GET_NEW_GATEWAY}${payload}`);
  }

  getGateWaysByDestination(id) {
    return axios.get(`${HOTEL_URL}${ApiKey.GET_GATEWAYS}/dest/${id}`);
  }

  getGateWaysByDestinationDuration(destId, duration) {
    return axios.get(`${HOTEL_URL}${ApiKey.GET_GATEWAYS}/dest-duration/${destId}/${duration}`);
  }

  getGatewayDuration(payload) {
    return axios.post(`${HOTEL_URL}${ApiKey.GATE_DURATIONS}/additional-duration`, payload);
  }

  getDestinationsByGateCode(gateCode) {
    return axios.get(`${HOTEL_URL}${ApiKey.GATE_DURATIONS}/${gateCode}`);
  }
}
